// @flow
import { Component, type Node } from 'react';

type Props = {|
  children: Node,
|};

type State = {|
  errorIsCaught: boolean,
|};

export default class ErrorBoundary extends Component<Props, State> {
  state = {
    errorIsCaught: false,
  };

  // no hook equivalent yet. https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes
  componentDidCatch() {
    this.setState({ errorIsCaught: true });
  }

  render() {
    const { children } = this.props;
    const { errorIsCaught } = this.state;
    return errorIsCaught ? null : children;
  }
}
